import { useEffect } from "react";

const SITE_URL = "https://teamwork-africa.com";
const DEFAULT_IMAGE = SITE_URL + "/logo-teamwork.png";

function setMeta(attribute, key, content) {
  if (content == null || content === "") return;
  let el = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attribute, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", String(content));
}

export default function Seo({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  imageAlt = "Team Work Africa",
  type = "website",
  schema,
  noindex = false,
}) {
  useEffect(() => {
    const canonical = new URL(path, SITE_URL).toString();
    document.title = title;
    const robots = noindex
      ? "noindex,follow,noarchive"
      : "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1";

    setMeta("name", "description", description);
    setMeta("name", "robots", robots);
    setMeta("name", "googlebot", robots);
    setMeta("name", "bingbot", robots);

    setMeta("property", "og:locale", "fr_FR");
    setMeta("property", "og:type", type);
    setMeta("property", "og:site_name", "Team Work Africa");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", canonical);
    setMeta("property", "og:image", image);
    setMeta("property", "og:image:alt", imageAlt);

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = canonical;

    const id = "teamwork-page-schema";
    document.getElementById(id)?.remove();
    if (schema) {
      const script = document.createElement("script");
      script.id = id;
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    }

    return () => document.getElementById(id)?.remove();
  }, [title, description, path, image, imageAlt, type, schema, noindex]);

  return null;
}
